import { render, staticRenderFns } from "./areaUserList.vue?vue&type=template&id=a15a3688&scoped=true&"
import script from "./areaUserList.vue?vue&type=script&lang=js&"
export * from "./areaUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a15a3688",
  null
  
)

export default component.exports